import { useCallback, useEffect, useReducer } from "react";
import { FullUserCredentialingDetails } from "./types";
import { getFullUserCredentialing } from "./service";
import { ResponseStatus } from "lib/http/types";

export enum SelectedNetwork {
  INTERNAL = "internal",
  FULL_10URE = "full10ure",
  INVITES = "invites",
  APPLICANTS = "applicants",
}

interface NetworkSearchParams {
  userRefId: string;
  countryAlpha2?: string;
}

interface NetworkSearchState {
  isLoading: boolean;
  error: string | null;
  userDetails: FullUserCredentialingDetails | null;
}
const initialState: NetworkSearchState = {
  error: null,
  isLoading: true,
  userDetails: null,
};

function paramsReducer(
  state: NetworkSearchState,
  action: Partial<NetworkSearchState>
): NetworkSearchState {
  return {
    ...state,
    ...action,
  };
}

export function useFullCurrentUserInformation(options: NetworkSearchParams) {
  const { userRefId, countryAlpha2 } = options;
  const [{ isLoading, error, userDetails }, dispatch] = useReducer(
    paramsReducer,
    initialState
  );

  const callSearch = useCallback(async (): Promise<any> => {
    dispatch({
      error: null,
      isLoading: true,
    });
    const result = await getFullUserCredentialing();
    if (result.status === ResponseStatus.SUCCESS) {
      dispatch({
        userDetails: result.body,
      });
    } else {
      dispatch({ error: `error getting searchResults: ${result.error}` });
    }
    dispatch({ isLoading: false });
  }, [dispatch]);

  const callNewSearch = () => {
    // Dont call if internal but no refId
    if (!userRefId) {
      return;
    }
    callSearch();
  };

  useEffect(() => {
    // Dont call if no refId
    if (!userRefId) {
      return;
    }
    callSearch();
  }, [userRefId, countryAlpha2]);

  return {
    callNewSearch,
    error,
    isLoading,
    userDetails,
  };
}
